export enum ViewModeEnum {
  TABLE_VIEW = 0,
  CARD_VIEW = 1
}
